module.exports = __webpack_public_path__ + "img/symbol_10_x15.79e94d37.png";